module.exports = __webpack_public_path__ + "img/menu_2.01c65fc6.svg";